/**
 * Elmas Aydınlatma — Scroll Reveal Micro-Animations
 * Uses IntersectionObserver for performant CSS-driven reveals.
 * Sections and cards fade + slide up as they enter the viewport.
 */
(function () {
  'use strict';

  var THRESHOLD = 0;
  var ROOT_MARGIN = '0px 0px 0px 0px';

  /* ------------------------------------------------------------------
     1. Mark all reveal-eligible elements
     ------------------------------------------------------------------ */
  function markElements() {
    // Section eyebrows
    document.querySelectorAll(
      '.elmas-section-head, .elmas-shead'
    ).forEach(function (el, i) {
      if (!el.hasAttribute('data-reveal')) {
        el.setAttribute('data-reveal', '');
        el.setAttribute('data-delay', Math.min(i * 50, 200));
      }
    });

    // Product / project / series cards — stagger within their parent grid
    document.querySelectorAll(
      '.elmas-prod-card, .elmas-proj-card, .elmas-series-card, .elmas-prive-card'
    ).forEach(function (el) {
      if (!el.hasAttribute('data-reveal')) {
        var siblings = el.parentElement
          ? el.parentElement.querySelectorAll(
              '.elmas-prod-card, .elmas-proj-card, .elmas-series-card, .elmas-prive-card'
            )
          : [];
        var idx = Array.prototype.indexOf.call(siblings, el);
        el.setAttribute('data-reveal', '');
        el.setAttribute('data-delay', String(Math.min(idx * 100, 500)));
      }
    });

    // Hero content, craft card, split promo panels, editorial panels
    document.querySelectorAll(
      '.elmas-hero__content, .elmas-craft__card, ' +
      '.elmas-split-promo__img, .elmas-split-promo__text, ' +
      '.elmas-editorial__panel-body, .elmas-kelvin__content, ' +
      '.elmas-trade__copy, .elmas-trade__bullets, ' +
      '.elmas-prive-hero__col'
    ).forEach(function (el) {
      if (!el.hasAttribute('data-reveal')) {
        el.setAttribute('data-reveal', '');
      }
    });
  }

  /* ------------------------------------------------------------------
     2. Observe and trigger
     ------------------------------------------------------------------ */
  function observe() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('[data-reveal]').forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, {
      threshold: THRESHOLD,
      rootMargin: ROOT_MARGIN
    });

    document.querySelectorAll('[data-reveal]').forEach(function (el) {
      // Already visible in viewport on load? Show immediately.
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        el.classList.add('is-visible');
      } else {
        io.observe(el);
      }
    });
  }

  /* ------------------------------------------------------------------
     3. Hover micro-interactions on product cards
     ------------------------------------------------------------------ */
  function cardHovers() {
    document.querySelectorAll(
      '.elmas-prod-card, .elmas-prive-card'
    ).forEach(function (card) {
      // Subtle title lift on hover (CSS handles the image scale already)
      var title = card.querySelector(
        '.elmas-prod-card__title, .elmas-prive-card__title'
      );
      if (title) {
        title.style.transition = 'transform 0.45s cubic-bezier(0.16,1,0.3,1)';
        card.addEventListener('mouseenter', function () {
          title.style.transform = 'translateY(-3px)';
        });
        card.addEventListener('mouseleave', function () {
          title.style.transform = '';
        });
      }
    });
  }

  /* ------------------------------------------------------------------
     4. Akilli header — scroll davranisi

     1. Baslangic: header akista (CSS: position relative), sayfayla kayip gider
     2. Header yuksekligini gecince tamamen gizlenmis olur
     3. Yukari scroll: fixed'e gecer, yukaridan asagi kayarak gelir
     4. Fixed'ken asagi scroll: translateY(-100%) ile gizlenir
     5. En tepede: fixed'ten cikar, tekrar akisa doner

     Konumlandirma CSS'te (.elmas-header-fixed / .is-hidden). Burada yalnizca
     durum yonetiliyor — boylece inline stil ile CSS birbiriyle cakismiyor.
     ------------------------------------------------------------------ */
  function headerScroll() {
    var h = document.getElementById('elmas-header');
    var section = document.getElementById('shopify-section-header');
    if (!h || !section) return;

    // Fixed'e gecince header akistan cikar ve sayfa yukari ziplar; bosluk tutucu bunu onler
    var spacer = document.createElement('div');
    spacer.setAttribute('aria-hidden', 'true');
    spacer.style.display = 'none';
    section.after(spacer);

    var headerH = section.offsetHeight || 150;
    // "anchor": son yon karari alinan scroll konumu. Kare-kare fark yerine
    // ANKORDAN net mesafe kullaniyoruz — cunku `html{scroll-behavior:smooth}`
    // programatik/tekerlek scroll'unu animasyonla yumusatiyor ve bu, ardisik
    // rAF karelerinde gecici ters yonlu okumalar uretebiliyor (asagi kaydirirken
    // bile ara karede y bir onceki kareden kucuk cikabiliyor). Ankor sadece
    // esik asildiginda hareket ettigi icin bu turden kisa sicramalar birikip
    // yanlis yon tetiklemez.
    var anchor = window.pageYOffset || document.documentElement.scrollTop || 0;
    var isFixed = false;
    var isHidden = false;
    var ticking = false;

    var THRESHOLD = 30; // ankordan bu kadar net mesafe alinmadan yon degismez
    var TOP_ZONE = 10;   // "en tepe" tolerensi (10px)
    var REVEAL_THRESHOLD = 200; // Eşik Değeri: 200px aşağı inene kadar fixed olmaz

    function toFixed() {
      if (isFixed) return;
      isFixed = true;
      isHidden = false;

      spacer.style.height = headerH + 'px';
      spacer.style.display = 'block';

      // Once animasyonsuz olarak ekran ustune al...
      section.classList.add('no-anim', 'elmas-header-fixed', 'is-hidden');
      void section.offsetHeight; // reflow — bu olmadan tarayici iki adimi birlestirip animasyonu atlar
      // ...sonra animasyonu acip asagi kaydir
      section.classList.remove('no-anim', 'is-hidden');

      h.classList.add('elmas-header--scrolled');
    }

    function toFlow() {
      if (!isFixed) return;
      isFixed = false;
      isHidden = false;

      // transform'u tamamen birakmak onemli: transform'lu bir ata, icindeki
      // position:fixed mobil menuye containing block olur ve draweri bozar
      section.classList.add('no-anim');
      section.classList.remove('elmas-header-fixed', 'is-hidden');
      void section.offsetHeight;
      section.classList.remove('no-anim');

      h.classList.remove('elmas-header--scrolled');
      spacer.style.display = 'none';
    }

    function hide() {
      if (!isFixed || isHidden) return;
      isHidden = true;
      section.classList.add('is-hidden');
    }

    function show() {
      if (!isFixed || !isHidden) return;
      isHidden = false;
      section.classList.remove('is-hidden');
    }

    function applyPrive(y) {
      var isPrive = document.body.classList.contains('template-collection-prive') ||
                    document.documentElement.getAttribute('data-elmas-mode') === 'prive';
      if (!isPrive) return;

      var solid = y > 60;
      h.style.backgroundColor   = solid ? 'var(--elmas-header-bg)' : 'transparent';
      h.style.backdropFilter    = solid ? 'blur(20px)' : 'none';
      h.style.webkitBackdropFilter = solid ? 'blur(20px)' : 'none';
      h.style.borderBottomColor = solid ? 'var(--elmas-border)' : 'transparent';
    }

    function update() {
      ticking = false;
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;

      applyPrive(y);

      // 1. Başa dönüş — akista, fixed'ten tamamen cik
      if (y <= TOP_ZONE) {
        toFlow();
        anchor = y;
        return;
      }

      var diff = y - anchor;

      if (diff <= -THRESHOLD) {
        // 2. Geri Çağırma (Reveal): Yukarı kaydırırken fixed moda geç ve göster
        if (y > REVEAL_THRESHOLD) {
          if (!isFixed) { 
            toFixed(); 
          } else if (isHidden) { 
            show(); 
          }
        }
        anchor = y;
      } else if (diff >= THRESHOLD) {
        // 3. Tekrar Aşağı Kaydırma: Sabitlenmişken aşağı kaydırılırsa gizle
        if (isFixed && !isHidden) {
          hide();
        }
        anchor = y;
      }
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () {
      // Akistayken olcebiliriz; fixed'ken offsetHeight zaten dogru ama spacer'i tazeleyelim
      if (!isFixed) {
        headerH = section.offsetHeight || headerH;
      } else {
        spacer.style.height = headerH + 'px';
      }
    }, { passive: true });

    update();
  }

  /* ------------------------------------------------------------------
     5. Hamburger mobile menu toggle
     ------------------------------------------------------------------ */
  function initMobileMenu() {
    var btn = document.getElementById('elmas-hamburger-btn');
    var nav = document.getElementById('elmas-mobile-nav');
    if (!btn || !nav) return;

    btn.addEventListener('click', function () {
      var isOpen = nav.classList.toggle('open');
      var menuIcon = btn.querySelector('.elmas-icon-menu');
      var closeIcon = btn.querySelector('.elmas-icon-close');
      
      if (isOpen) {
        if (menuIcon) menuIcon.style.display = 'none';
        if (closeIcon) closeIcon.style.display = 'block';
        document.body.style.overflow = 'hidden';
      } else {
        if (menuIcon) menuIcon.style.display = 'block';
        if (closeIcon) closeIcon.style.display = 'none';
        document.body.style.overflow = '';
      }
    });
  }

  /* ------------------------------------------------------------------
     6. Category Mosaic Slider dots active trigger
     ------------------------------------------------------------------ */
  function initMosaicSlider() {
    var sliders = document.querySelectorAll('.elmas-mosaic');
    sliders.forEach(function (slider) {
      var parent = slider.parentElement;
      var dots = parent.querySelectorAll('.elmas-mosaic__dots span');
      if (dots.length === 0) return;

      slider.addEventListener('scroll', function () {
        var scrollLeft = slider.scrollLeft;
        var width = slider.clientWidth;
        if (width === 0) return;
        var activeIndex = Math.round(scrollLeft / (width * 0.8)); // 0.8 card width ratio
        if (activeIndex >= dots.length) activeIndex = dots.length - 1;
        
        dots.forEach(function (dot, idx) {
          if (idx === activeIndex) {
            dot.classList.add('active');
          } else {
            dot.classList.remove('active');
          }
        });
      }, { passive: true });
    });
  }

  /* ------------------------------------------------------------------
     7. Init
     ------------------------------------------------------------------ */
  function init() {
    markElements();
    observe();
    cardHovers();
    headerScroll();
    initMobileMenu();
    initMosaicSlider();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
